module.exports = __webpack_public_path__ + "img/mx.a471956.png";